export { default } from "./FeaturedDispensariesSection";
